module.exports = __webpack_public_path__ + "img/attendance.37639588.png";